module.exports = __webpack_public_path__ + "img/communication16.9ca0c240.png";